
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[schoolSlug]",
      function () {
        return require("private-next-pages/[schoolSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[schoolSlug]"])
      });
    }
  